import { isLocalStorageEnabled } from 'app/assets/javascripts/utils/localstorage';

const LOCAL_STORAGE_KEY = 'contentGate';
// Only count documents seen in the last 30 days. The value is in milliseconds
const PERIOD_TO_LOOK_BACK = 30 * 24 * 60 * 60 * 1000;

export default class Model {
  constructor(storage = null) {
    if (storage) {
      this.storage = storage;
    } else {
      this.storage = new StorageBackend();
    }
  }

  trackView(id, testVersion) {
    this.withState((state) => {
      // Test got a new version
      if (
        Number.isInteger(state.testVersion) &&
        state.testVersion != testVersion
      ) {
        state.testVersion = testVersion;
        state.documents = [];
      }

      // We just got an assignment, set the test version in state
      if (
        !Number.isInteger(state.testVersion) &&
        Number.isInteger(testVersion)
      ) {
        state.testVersion = testVersion;
      }

      if (!Array.isArray(state.documents)) {
        state.documents = [];
      }

      const expiredTimestamp = new Date(
        this.storage.now().getTime() - PERIOD_TO_LOOK_BACK
      ).toISOString();

      state.documents = state.documents
        .filter(isValidEntry)
        .filter((d) => d.at > expiredTimestamp)
        .filter((d) => `${d.id}` != `${id}`);

      state.documents.push({ id: id, at: this.storage.now() });

      this.documents = state.documents;
    });
  }

  get numberOfViewedDocuments() {
    if (!Array.isArray(this.documents)) {
      throw new Error('getting number of viewed documents before adding one');
    }

    return this.documents.length;
  }

  withState(fn) {
    let state = this.storage.load(LOCAL_STORAGE_KEY);
    fn(state || {});
    this.storage.save(LOCAL_STORAGE_KEY, state);
  }
}

const hasValidId = (id) => !!id && typeof id === 'string';
const hasValidDate = (dateTime) => !!dateTime && getIsValidIsoDate(dateTime);
export const getIsValidIsoDate = (dateStr) => {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(dateStr)) {
    return false;
  } else {
    return new Date(dateStr).toISOString() === dateStr;
  }
};

function isValidEntry(entry) {
  return hasValidId(entry.id) && hasValidDate(entry.at);
}

// This class is made purely so it can be mocked
// out in tests
class StorageBackend {
  now() {
    return new Date();
  }

  load(name) {
    if (!isLocalStorageEnabled()) {
      return null;
    }

    return JSON.parse(window.localStorage.getItem(name) || '{}');
  }

  save(name, value) {
    if (!isLocalStorageEnabled()) {
      return null;
    }

    window.localStorage.setItem(name, JSON.stringify(value));
  }

  remove(name) {
    if (!isLocalStorageEnabled()) {
      return;
    }

    window.localStorage.removeItem(name);
  }
}
